import React from 'react';
import { WavyDivider } from 'src/shared/design-system/WavyEdge';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.HALF};
  align-items: center;
  color: ${Colors.GRAY_DARK_30};
  width: max-content;
`;

const IconContainer = styled.div`
  border-radius: 100%;
  background-color: ${Colors.RADISH_LITE_10};
  font-size: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderText = styled.span`
  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.XXL};
  line-height: ${Font.LineHeight.XXL};
  font-weight: ${Font.Weight.SEMI_BOLD};
  letter-spacing: 0;
  text-align: center;
`;

interface IProps {
  className?: string;
  icon?: React.ReactNode;
  text?: string;
}
export const HeaderBlock: React.FC<IProps> = ({ className, icon, text }) => (
  <HeaderContainer className={`${className}`}>
    <IconContainer>{icon}</IconContainer>
    <HeaderText>{text}</HeaderText>
    <WavyDivider className='w-full' />
  </HeaderContainer>
);
